import { Card, Container, Eyebrow, Section, SectionTitle } from '@vcn/ui'
import { useContent } from "../content";

export function Trust() {
  const { trust } = useContent();

  return (
    <Section id="sicherheit" className="scroll-mt-20">
      <Container>
        <div className="text-center">
          <Eyebrow>{trust.eyebrow}</Eyebrow>
          <SectionTitle className="mt-4">{trust.title}</SectionTitle>
        </div>

        <ul className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {trust.cards.map((card) => (
            <li key={card.eyebrow} className="contents">
              <Card className="flex flex-col text-center">
                <Eyebrow as="p" className="text-[0.7rem] tracking-[0.16em]">
                  {card.eyebrow}
                </Eyebrow>

                <h3 className="mt-3 text-xl leading-tight font-bold text-balance text-white">
                  {card.title.map((line) => (
                    <span key={line} className="block">
                      {line}
                    </span>
                  ))}
                </h3>

                <p className="mt-4 text-[0.9rem] leading-relaxed text-pretty text-white/85">
                  {card.body}
                </p>
              </Card>
            </li>
          ))}
        </ul>
      </Container>
    </Section>
  )
}
